import { render } from "./AppTemplate.vue?vue&type=template&id=0504c21f&scoped=true"
import script from "./AppTemplate.vue?vue&type=script&lang=js"
export * from "./AppTemplate.vue?vue&type=script&lang=js"

import "./AppTemplate.vue?vue&type=style&index=0&id=0504c21f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0504c21f"]])

export default __exports__